import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

/* Offer and sale differ only in a colour and the order of two prices, so both
   live in one static class and swap a CSS variable through a data attribute.
   That keeps a single injected rule however many cards a listing renders, rather
   than one class per emphasis. */
const emphasis = css`
  --price-emphasis: var(${colors.content.default});

  &[data-emphasis='offer'] {
    --price-emphasis: var(${colors.content.positive});
  }

  &[data-emphasis='sale'] {
    --price-emphasis: var(${colors.content.negative});
  }
`;

export const priceRow = css`
  ${emphasis}

  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(${spacing.xs});
  margin: 0;
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  color: var(${colors.content.default});
`;

export const prices = css`
  display: flex;
  align-items: baseline;
  gap: var(${spacing.xxs});
  min-width: 0;
`;

/* The tag only appears alongside a sale, so it inherits the emphasis colour
   rather than naming the negative token again. */
export const saleIcon = css`
  display: inline-flex;
  flex-shrink: 0;
  align-self: center;
  line-height: 0;
  color: var(--price-emphasis);
`;

/* The theme has one body weight and no bold token, so bold is stated as a literal
   here as it is in the core Button. Worth a token if a third component needs it. */
export const price = css`
  font-weight: 700;
  color: var(--price-emphasis);
  white-space: nowrap;
`;

export const originalPrice = css`
  font-size: var(${typography.body.sizes.sm.fontSize});
  color: var(${colors.content.secondary});
  white-space: nowrap;
  /* Stated rather than left to the user agent's default for <s>, so the
     strike-through is part of the component's contract. */
  text-decoration: line-through;
`;

export const discount = css`
  ${emphasis}

  margin: 0;
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});
  color: var(--price-emphasis);
`;
